<template>
    <div class="bonusomat-main floor bs-container">
        <div class="bonusomat-main__column">
            <div class="bonusomat-main__section bonusomat-main__section--double">
                <BonusomatSlots />
                <BonusomatRaffle />
            </div>
            <div class="bonusomat-main__section bonusomat-main__section--board">
                <BonusomatBoard />
            </div>
        </div>
        <div class="bonusomat-main__column bonusomat-main__column--quests">
            <div class="bonusomat-main__section bonusomat-main__section--quests">
                <BonusomatQuests />
            </div>
        </div>
    </div>
    <BonusomatOnboarding />
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import { useKeepAlive } from "@sazka/ng/ng-keep-session-alive";
import BonusomatBoard from "./board/bonusomat-board.vue";
import BonusomatOnboarding from "./onboarding/bonusomat-onboarding.vue";
import BonusomatQuests from "./quests/bonusomat-quests.vue";
import BonusomatRaffle from "./raffle/bonusomat-raffle.vue";
import BonusomatSlots from "./slots/bonusomat-slots.vue";
import useBonusomatData from "../composables/use-bonusomat-data";
import { BonusomatDatalayer } from "../utils/analytics/bonusomat-datalayer";

const { initBonusomatData } = useBonusomatData();

initBonusomatData();

onMounted(async () => {
    BonusomatDatalayer.pushMainPageShow();
    useKeepAlive();
});
</script>
